<div class="flex min-h-screen bg-white">
  <!-- Partie gauche - Image -->
  <div class="w-1/2 hidden md:block image-container">
    <img src="assets/Innov.png" alt="Innov Impact Africa"
      class="object-cover w-[678] h-[910] mx-auto py-4" />
  </div>

  <!-- Partie droite - Formulaire -->
  <div class="w-full md:w-1/2 flex flex-col justify-center px-8 py-12">
    <div class="max-w-lg mx-auto w-full">
      <!-- Logo -->
      <div class="text-center mb-6">
        <img src="assets/images/UKUBHALISA.png" alt="Logo UKUBHALISA" class="h-12 mx-auto mb-4" />
      </div>

      <!-- Language Selector -->
      <div class="flex justify-end mb-4">
        <div class="relative">
          <button (click)="showLangDropdown = !showLangDropdown"
            class="flex items-center gap-2 px-4 py-2.5 bg-white border rounded-xl shadow-sm hover:shadow-md transition-all" style="border-color: rgba(6, 57, 112, 0.2)">
            <span class="text-xl leading-none">{{ languageService.currentLang() === 'FR' ? '🇫🇷' : '🇬🇧' }}</span>
            <span class="text-sm font-semibold text-gray-700">{{ languageService.currentLang() }}</span>
            <svg class="w-4 h-4 text-gray-500 transition-transform" [class.rotate-180]="showLangDropdown" fill="none"
              stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <!-- Dropdown -->
          <div *ngIf="showLangDropdown"
            class="absolute right-0 mt-2 w-40 bg-white border rounded-xl shadow-xl z-50 overflow-hidden" style="border-color: rgba(6, 57, 112, 0.2)">
            <button (click)="languageService.changeLanguage('FR'); showLangDropdown = false"
              class="w-full flex items-center gap-3 px-4 py-3 transition-colors"
              [style.background-color]="languageService.currentLang() === 'FR' ? 'rgba(6, 57, 112, 0.1)' : ''">
              <span class="text-xl">🇫🇷</span>
              <span class="text-sm font-medium text-gray-700">Français</span>
              <svg *ngIf="languageService.currentLang() === 'FR'" class="w-5 h-5 ml-auto" style="color: #063970"
                fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd" />
              </svg>
            </button>
            <button (click)="languageService.changeLanguage('EN'); showLangDropdown = false"
              class="w-full flex items-center gap-3 px-4 py-3 transition-colors"
              [style.background-color]="languageService.currentLang() === 'EN' ? 'rgba(6, 57, 112, 0.1)' : ''">
              <span class="text-xl">🇬🇧</span>
              <span class="text-sm font-medium text-gray-700">English</span>
              <svg *ngIf="languageService.currentLang() === 'EN'" class="w-5 h-5 ml-auto" style="color: #063970"
                fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Header -->
      <div class="text-center mb-6">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 shadow-lg"
          [style.background]="'linear-gradient(to bottom right, #063970, #084a8c)'">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
        </div>
        <h1 class="text-3xl font-bold mb-2"
          [style.background]="'linear-gradient(to right, #ffffff, #084a8c)'"
          style="-webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">
          Créer votre compte
        </h1>
        <p class="text-gray-600">Rejoignez UKUBHALISA et gérez vos projets efficacement</p>
      </div>

      <!-- Messages de succès -->
      <div *ngIf="successMessage" class="bg-green-50 border border-green-200 text-green-800 p-4 rounded-xl mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        {{ successMessage }}
      </div>

      <!-- Messages d'erreur -->
      <div *ngIf="errorMessage" class="bg-red-50 border border-red-200 text-red-800 p-4 rounded-xl mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        {{ errorMessage }}
      </div>

      <!-- Affichage des erreurs de validation -->
      <div *ngIf="validationErrors.length > 0" class="bg-red-50 border border-red-200 text-red-800 p-4 rounded-xl mb-6">
        <ul class="list-disc list-inside space-y-1">
          <li *ngFor="let error of validationErrors">{{ error }}</li>
        </ul>
      </div>

      <!-- Progress indicator -->
      <div class="flex items-center justify-center gap-2 mb-6">
        <div class="w-8 h-2 rounded-full" [style.background-color]="currentStep >= 1 ? '#063970' : 'rgba(6, 57, 112, 0.2)'"></div>
        <div class="w-8 h-2 rounded-full" [style.background-color]="currentStep >= 2 ? '#063970' : 'rgba(6, 57, 112, 0.2)'"></div>
      </div>

      <!-- Formulaire d'inscription -->
      <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
        <!-- Étape 1: Informations personnelles -->
        <div *ngIf="currentStep === 1">
          <div class="grid grid-cols-1 gap-5">
            <!-- Nom -->
            <div>
              <label class="block text-gray-700 font-semibold mb-2 flex items-center gap-2">
                <svg class="w-5 h-5" style="color: #063970" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                {{ t('auth.register.lastNameLabel') }} <span class="text-red-500">*</span>
              </label>
              <input formControlName="nom" (input)="onFieldInput('nom')"
                class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all hover:bg-gray-100"
                [placeholder]="t('auth.register.lastNamePlaceholder')" />
              <div *ngIf="f['nom'].touched && f['nom'].invalid" class="text-red-500 text-sm mt-1 flex items-center gap-1">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                <span *ngIf="f['nom'].errors?.['required']">{{ t('auth.register.error.lastNameRequired') }}</span>
                <span *ngIf="f['nom'].errors?.['minlength']">{{ t('auth.register.error.lastNameRequired') }}</span>
              </div>
            </div>

            <!-- Prénom -->
            <div>
              <label class="block text-gray-700 font-semibold mb-2 flex items-center gap-2">
                <svg class="w-5 h-5" style="color: #063970" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                {{ t('auth.register.firstNameLabel') }} <span class="text-red-500">*</span>
              </label>
              <input formControlName="prenom" (input)="onFieldInput('prenom')"
                class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all hover:bg-gray-100"
                [placeholder]="t('auth.register.firstNamePlaceholder')" />
              <div *ngIf="f['prenom'].touched && f['prenom'].invalid" class="text-red-500 text-sm mt-1 flex items-center gap-1">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                <span *ngIf="f['prenom'].errors?.['required']">{{ t('auth.register.error.firstNameRequired') }}</span>
                <span *ngIf="f['prenom'].errors?.['minlength']">{{ t('auth.register.error.firstNameRequired') }}</span>
              </div>
            </div>

            <!-- Email -->
            <div>
              <label class="block text-gray-700 font-semibold mb-2 flex items-center gap-2">
                <svg class="w-5 h-5" style="color: #063970" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                {{ t('auth.register.emailLabel') }} <span class="text-red-500">*</span>
              </label>
              <input type="email" formControlName="email" (input)="onFieldInput('email')"
                class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all hover:bg-gray-100"
                [placeholder]="t('auth.register.emailPlaceholder')" />
              <div *ngIf="f['email'].touched && f['email'].invalid" class="text-red-500 text-sm mt-1 flex items-center gap-1">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                <span *ngIf="f['email'].errors?.['required']">{{ t('auth.register.error.emailRequired') }}</span>
                <span *ngIf="f['email'].errors?.['email']">{{ t('auth.register.error.emailInvalid') }}</span>
              </div>
            </div>

            <!-- Téléphone -->
            <div>
              <label class="block text-gray-700 font-semibold mb-2 flex items-center gap-2">
                <svg class="w-5 h-5" style="color: #063970" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                {{ t('auth.register.phoneLabel') }} <span class="text-red-500">*</span>
              </label>
              <input formControlName="telephone" (input)="onFieldInput('telephone')"
                class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all hover:bg-gray-100"
                [placeholder]="t('auth.register.phonePlaceholder')" />
              <div *ngIf="f['telephone'].touched && f['telephone'].invalid" class="text-red-500 text-sm mt-1 flex items-center gap-1">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                <span *ngIf="f['telephone'].errors?.['required']">{{ t('auth.register.error.phoneRequired') }}</span>
                <span *ngIf="f['telephone'].errors?.['pattern']">{{ t('auth.register.error.phoneInvalid') }}</span>
              </div>
            </div>

            <!-- Mot de passe -->
            <div>
              <label class="block text-gray-700 font-semibold mb-2 flex items-center gap-2">
                <svg class="w-5 h-5" style="color: #063970" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                {{ t('auth.register.passwordLabel') }} <span class="text-red-500">*</span>
              </label>
              <input type="password" formControlName="password" (input)="onFieldInput('password')"
                class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all hover:bg-gray-100"
                [placeholder]="t('auth.register.passwordPlaceholder')" />
              <div *ngIf="f['password'].touched && f['password'].invalid" class="text-red-500 text-sm mt-1 flex items-center gap-1">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                <span *ngIf="f['password'].errors?.['required']">{{ t('auth.register.error.passwordRequired') }}</span>
                <span *ngIf="f['password'].errors?.['minlength']">{{ t('auth.register.error.passwordMinLength') }}</span>
              </div>
            </div>

            <!-- Profil utilisateur -->
            <div>
              <label class="block text-gray-700 font-semibold mb-2 flex items-center gap-2">
                <svg class="w-5 h-5" style="color: #063970" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                {{ t('auth.register.profileLabel') }} <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <select formControlName="profil" (change)="onProfileChange($event)" (change)="onFieldInput('profil')"
                  class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all appearance-none cursor-pointer hover:bg-gray-100">
                  <option value="" disabled selected>{{ t('auth.register.profilePlaceholder') }}</option>
                  <option *ngFor="let profile of availableProfiles" [value]="profile.value">
                    {{ profile.displayName }}
                  </option>
                </select>
                <div class="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                  <svg class="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
              <div *ngIf="f['profil'].touched && f['profil'].invalid" class="text-red-500 text-sm mt-1 flex items-center gap-1">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                <span *ngIf="f['profil'].errors?.['required']">{{ t('auth.register.error.profileRequired') }}</span>
              </div>
            </div>
          </div>

          <!-- Bouton Suivant -->
          <button type="button" (click)="nextStep()"
            class="w-full mt-6 text-white py-4 rounded-xl font-semibold transition-all transform hover:scale-[1.02] shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
            [style.background]="'linear-gradient(to right, #063970, #084a8c)'">
            <span>Suivant</span>
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        <!-- Étape 2: Informations complémentaires -->
        <div *ngIf="currentStep === 2">
          <div class="grid grid-cols-1 gap-5">
            <!-- Adresse -->
            <div>
              <label class="block text-gray-700 font-semibold mb-2 flex items-center gap-2">
                <svg class="w-5 h-5" style="color: #063970" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                {{ t('auth.register.addressLabel') }} <span class="text-red-500">*</span>
              </label>
              <input formControlName="adress" (input)="onFieldInput('adress')"
                class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all hover:bg-gray-100"
                [placeholder]="t('auth.register.addressPlaceholder')" />
              <div *ngIf="f['adress'].touched && f['adress'].invalid" class="text-red-500 text-sm mt-1 flex items-center gap-1">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                <span *ngIf="f['adress'].errors?.['required']">{{ t('auth.register.error.addressRequired') }}</span>
              </div>
            </div>

            <!-- Photo de profil (optionnelle) -->
            <div>
              <label class="block text-gray-700 font-semibold mb-2 flex items-center gap-2">
                <svg class="w-5 h-5" style="color: #063970" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                {{ t('team.profilePhoto') }}
              </label>

              <!-- Zone d'upload -->
              <div class="flex items-start gap-4">
                <!-- Aperçu de la photo -->
                <div *ngIf="photoPreview" class="flex-shrink-0">
                  <div class="relative w-28 h-28 rounded-2xl overflow-hidden border-2 shadow-lg" style="border-color: rgba(6, 57, 112, 0.2)">
                    <img [src]="photoPreview" alt="Aperçu" class="w-full h-full object-cover">
                    <button type="button" (click)="removePhoto()"
                      class="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1.5 hover:bg-red-600 transition-colors shadow-md">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                        </path>
                      </svg>
                    </button>
                  </div>
                </div>

                <!-- Input file -->
                <div class="flex-1">
                  <input type="file" id="photo" name="photo" accept="image/*" (change)="onPhotoSelected($event)"
                    class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all hover:bg-gray-100 file:mr-4 file:py-2 file:px-4 file:rounded-xl file:border-0 file:text-sm file:font-semibold "
                    style="--tw-file-bg: rgba(6, 57, 112, 0.1); --tw-file-text: #063970; --tw-file-hover-bg: rgba(6, 57, 112, 0.2)" />
                  <p class="mt-2 text-xs text-gray-500 flex items-center gap-1">
                    📸 {{ t('team.acceptedFormats') }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Date de naissance (optionnel) -->
            <div>
              <label class="block text-gray-700 font-semibold mb-2 flex items-center gap-2">
                <svg class="w-5 h-5" style="color: #063970" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                {{ t('team.birthDate') }}
              </label>
              <input type="date" formControlName="dateOfBirth" (input)="onFieldInput('dateOfBirth')"
                class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all hover:bg-gray-100" />
            </div>
          </div>

          <!-- Boutons -->
          <div class="flex gap-3 mt-6">
            <!-- Bouton Retour -->
            <button type="button" (click)="previousStep()"
              class="flex-1 text-gray-700 py-4 rounded-xl font-semibold transition-all transform hover:scale-[1.02] border border-gray-300 hover:border-gray-400 flex items-center justify-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
              <span>Retour</span>
            </button>

            <!-- Bouton S'inscrire -->
            <button type="submit" [disabled]="isLoading"
              class="flex-1 text-white py-4 rounded-xl font-semibold transition-all transform hover:scale-[1.02] disabled:cursor-not-allowed disabled:transform-none shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
              [style.background]="isLoading ? 'linear-gradient(to right, #4a6fa5, #5a7fb5)' : 'linear-gradient(to right, #063970, #084a8c)'"
              [style.opacity]="isLoading ? 0.7 : 1">
              <span *ngIf="!isLoading" class="flex items-center gap-2">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
                {{ t('auth.register.registerButton') }}
              </span>
              <span *ngIf="isLoading" class="flex items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                {{ t('auth.register.registering') }}
              </span>
            </button>
          </div>
        </div>

        <!-- Lien vers la connexion -->
        <div class="text-center mt-6">
          <p class="text-gray-600">
            {{ t('auth.register.alreadyHaveAccount') }}
            <a routerLink="/login" class="font-semibold underline decoration-2 transition-all" style="color: #063970">{{
              t('auth.register.loginLink') }}</a>
          </p>
        </div>
      </form>
    </div>
  </div>
</div>